import { trpc } from "@/trpc/client";
import { getDataToken } from "@/services";
import { applyCampaignSiteSlugNames } from "@/utils/campaignSiteSlug";
import {
  campaignHeader,
  campaignLocations,
  campaignPlacements,
  campaignPurchaseTree,
  creativeHeatmaps,
  dailySites,
  locationSites,
  urlSites,
} from "@/trpc/calls";
import { campaignIdFrom, readDateRange, siteIdFrom } from "@/trpc/listFilter";

const sitesData = async (variables) => {
  const campaignId = campaignIdFrom(variables);
  if (!campaignId) return [];
  const result = await trpc.lookups.sites.list.query({
    limit: 500,
    offset: 0,
    campaign_ids: [campaignId],
  });
  return result.rows ?? [];
};

const getDataCampaign = async (variables) => campaignHeader(variables);

const CPM_getData = async (variables) => {
  const campaign = await campaignPurchaseTree(variables);
  return applyCampaignSiteSlugNames(campaign, variables);
};

const CPC_getData = async (variables) => {
  const campaign = await campaignPurchaseTree(variables);
  return applyCampaignSiteSlugNames(campaign, variables);
};

const CPV_getData = async (variables) => {
  const campaign = await campaignPurchaseTree(variables);
  return applyCampaignSiteSlugNames(campaign, variables);
};

const Daily_Delivery_getData = async (variables) => {
  const rows = await dailySites(variables);
  return applyCampaignSiteSlugNames({ sites: rows }, variables);
};

const getPlacements = async (variables) => campaignPlacements(variables);

const getCreativeHeatmaps = async (variables) => creativeHeatmaps(variables);

const getTableMap = async (variables) => campaignLocations(variables);

const getTableMapSite = async (variables) => {
  const locations = await campaignLocations(variables);
  return applyCampaignSiteSlugNames(locations, variables);
};

const getVehicle = async (variables) => {
  const campaign = await campaignPurchaseTree(variables);
  return applyCampaignSiteSlugNames(campaign, variables);
};

const getMap = async (variables) => {
  const campaign = await campaignLocations(variables);
  if (campaign?.campaign) return campaign;
  return { campaign };
};

const getChartVerification = async (variables) => {
  const response = await urlSites(variables);
  return applyCampaignSiteSlugNames(response, variables);
};

const getDomainOverlay = async (variables) => {
  const response = await urlSites(variables);
  return applyCampaignSiteSlugNames(response, variables);
};

const getWrapperWorld = async (variables) => {
  const campaign = await campaignLocations(variables);
  if (campaign?.campaign) return campaign;
  return { campaign };
};

const getTableWorld = async (variables) => {
  const response = await locationSites(variables);
  return applyCampaignSiteSlugNames(response, variables);
};

const getScroll = async (variables) => {
  const rows = await dailySites(variables);
  return applyCampaignSiteSlugNames(rows, variables);
};

const getGET_PURCHASES_TYPES_TOTAL = async (variables) => {
  const campaign = await campaignPurchaseTree(variables);
  return [campaign].filter(Boolean);
};

const getGET_PURCHASES_TYPES_TOTAL_CategorySafeframe = async (variables) => {
  const base = {
    campaign_id: campaignIdFrom(variables),
    ...(readDateRange(variables) || {}),
    ...(siteIdFrom(variables) ? { site_id: siteIdFrom(variables) } : {}),
    live: true,
  };
  if (!base.campaign_id) return [];
  const result = await trpc.analytics.siteChannelsQuality.query(base);
  return [result].filter(Boolean);
};

export {
  sitesData,
  getDataCampaign,
  CPM_getData,
  CPC_getData,
  CPV_getData,
  Daily_Delivery_getData,
  getDataToken,
  getPlacements,
  getCreativeHeatmaps,
  getTableMap,
  getTableMapSite,
  getVehicle,
  getMap,
  getChartVerification,
  getDomainOverlay,
  getWrapperWorld,
  getTableWorld,
  getScroll,
  getGET_PURCHASES_TYPES_TOTAL,
  getGET_PURCHASES_TYPES_TOTAL_CategorySafeframe,
};

